import { ITableConfig } from "@/components/table/table.model";
import { SORTING_DIR } from "@/common/models";

export const table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "",
      sortable: false,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "3rem",
      spanMax: "3rem",
    },
    {
      name: "File Name",
      key: "file_name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "24rem",
      spanMax: "1fr",
    },
    {
      name: "Information type",
      key: "info_label",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "1fr",
    },

    {
      name: "PIIs",
      key: "piis",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "1fr",
    },
    {
      name: "Sensitivity",
      key: "sensitivity",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "10rem",
    },
    {
      name: "Path",
      key: "path",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "10rem",
    },
  ],
};
